import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService, TenantService, UserService,} from '../../_services/index';
import {Tenant} from "../../_models";

@Component({
    standalone: false,
  selector: 'initialize-tenant-component',
  templateUrl: 'initializeTenant.component.html'
})

export class InitializeTenantComponent implements OnInit{
  loading: boolean;
  users: any[];
  tenant: Tenant;

  constructor(
    public dialogRef: MatDialogRef<InitializeTenantComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public tenantService: TenantService,
    public userService: UserService,
    public authenticationService: AuthenticationService) {
    this.tenant = data.tenant;
  }

  ngOnInit(): void {
    this.userService.getAllForTenant(this.tenant.databaseName).subscribe(u => this.users = u);
  }

  initializeTenant(): void {
    this.loading = true;
    this.tenantService.initializeTenant(this.tenant.tenantId).subscribe(data => {
      this.loading = false;
        this.dialogRef.close(true);
      },
      error => {
        this.loading = false;
        const errorMessage = 'An error occurred during tenant initialization.';
        this.alertService.error(errorMessage);
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
